import { createStore, combineReducers, compose, applyMiddleware } from 'redux'
import * as reducers from './reducers'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import thunk from 'redux-thunk'

const rootReducer = combineReducers({
    pages: reducers.pagesReducer,
    contacts: reducers.contactsReducer,
    users: reducers.usersReducer,
    auth: reducers.authReducer,
    global: reducers.globalReducer
})

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['users','global']
}

// Create store with reducers and initial state
const initialState = {
    pages: {},
    contacts: {},
    users: {},
    auth: {},
    global: {}
}

// Add BOTH store enhancers when making store creator
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = createStore(
    persistedReducer, 
    initialState, 
    composeEnhancers( applyMiddleware(thunk) )
)
export const persistor = persistStore(store)